// src/app/app.config.ts
import { APP_INITIALIZER, ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, TitleStrategy, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader, provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { firstValueFrom } from 'rxjs';

import { routes } from './app.routes';
import { TranslatedTitleStrategy } from '@/app/core/services/translated-title.strategy';
import { authInterceptor } from '@/app/core/interceptors/auth-interceptor';
import { LanguageService } from '@/app/core/language/services/language.service';
import { provideTracking } from '@/app/core/tracking/tracking.providers';

function initializeTranslations(translate: TranslateService, languageService: LanguageService) {
  return () => {
    const lang = languageService.getInitialLanguageKey();
    translate.setDefaultLang('es');
    translate.addLangs(['es', 'en']);
    return firstValueFrom(translate.use(lang));
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    { provide: TitleStrategy, useClass: TranslatedTitleStrategy },
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      })
    ),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideTranslateHttpLoader({ prefix: './i18n/', suffix: `.json?v=${Date.now()}` }),
    TranslateModule.forRoot({
      defaultLanguage: 'es',
      loader: {
        provide: TranslateLoader,
        useClass: TranslateHttpLoader,
      },
    }).providers!,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeTranslations,
      deps: [TranslateService, LanguageService],
      multi: true,
    },
    provideTracking(),
  ],
};
